import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

import { computed } from 'vue';

/**
 * Shared wrapper for the "informational row" / "clickable action row" pattern that kept getting
 * hand-rolled with raw `v-list-item`/`v-list-item-title` inside dropdown `#no-data`/`#append-item`
 * slots across the app (LienFormPanel, ClientMatterSearch, BillableTypePicker, AssignDistribution,
 * and others) — one shared component instead of each place re-inlining its own copy.
 * With `nav` it is also the row of a vertical navigation list (Settings, Overview).
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'LlListItem',
  props: {
    title: {},
    icon: {},
    color: {},
    clickable: { type: Boolean },
    nav: { type: Boolean },
    current: { type: Boolean },
    dataCy: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const COLOR_CLASSES: Record<string, string> = {
  error: 'text-red-600',
  success: 'text-green-700',
  muted: 'text-gray-500',
};

const props = __props;

const emit = __emit;

const titleClass = computed(() => {
  const colorClass = props.color ? COLOR_CLASSES[props.color] : '';
  // Inside a `<v-list nav>`, Vuetify's title rule (13px, weight 500) outranks plain utilities.
  if (props.nav) return ['!text-sm', colorClass, props.current ? '!font-medium' : '!font-normal'];
  return ['text-sm', colorClass, props.clickable ? 'font-medium' : ''];
});

function handleClick(): void {
  if (props.clickable || props.nav) emit('click');
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!

  return (_openBlock(), _createBlock(_component_v_list_item, {
    class: _normalizeClass({ 'cursor-pointer': __props.clickable || __props.nav, 'll-nav-current-y': __props.nav && __props.current }),
    "aria-current": __props.nav && __props.current ? 'page' : undefined,
    "data-cy": __props.dataCy,
    onClick: handleClick
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_list_item_title, {
        class: _normalizeClass(titleClass.value)
      }, {
        default: _withCtx(() => [
          (__props.icon)
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 0,
                size: "16",
                class: "mr-1"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.icon), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createTextVNode(_toDisplayString(__props.title), 1)
          ])
        ]),
        _: 3
      }, 8, ["class"])
    ]),
    _: 3
  }, 8, ["class", "aria-current", "data-cy"]))
}
}

})